document.addEventListener('turbolinks:load', () => {
  // TOPページ
  const heroEl = document.getElementsByClassName('home-hero')[0];
  // スキー場一覧ページ (/snow/search/areas/:code)
  const searchHeaderEl = document.getElementById('search-header');
  if (!heroEl && !searchHeaderEl) return;


  const thresholdY = heroEl ? heroEl.getBoundingClientRect().bottom : searchHeaderEl.getBoundingClientRect().bottom;
  const headerEl = document.getElementsByClassName('global-header-wrapper')[0];
  window.onscroll = () => {
    if (window.scrollY > thresholdY) {
      $('#global-site-header__stay-package-nav').collapse('show');
    } else {
      $('#global-site-header__stay-package-nav').collapse('hide');
      headerEl.style = 'borderRadius: 5px';
    };
  };
});
